import { APP_BASE_HREF } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, type OnInit } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { type IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCodeBranch, faExclamationTriangle, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { BE_API_URL } from '@reconcept-platform/shared/authentication';

@Component({
  selector: 'rcp-environment-indicator',
  template: `
    @if (environmentButtonShown) {
      <rcp-button [color]="this.color ?? 'neutral'" (click)="clickButton()" [icon]="this.icon">
        {{ this.text }}
      </rcp-button>
    }
  `,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class EnvironmentIndicatorComponent implements OnInit {
  private appBaseHref = inject(APP_BASE_HREF);
  private beApiUrl = inject(BE_API_URL);
  private library = inject(FaIconLibrary);

  @Input() environment: { [key: string]: any };

  reviewAppNumber: string | undefined;
  pullRequestNumber: string | undefined;
  currentEnvironment: string;
  environmentButtonShown = true;
  color: 'positive' | 'negative' | undefined;
  text: string;
  icon: IconProp;

  constructor() {
    this.library.addIcons(faCodeBranch, faTimes, faExclamationTriangle);
  }

  ngOnInit() {
    this.reviewAppNumber = this.getReviewAppNumber();
    this.pullRequestNumber = this.getPullRequestNumber();
    this.currentEnvironment = this.determineCurrentEnvironment();

    if (this.currentEnvironment === 'review-app') {
      this.color = undefined;
      this.text = `Review App #${this.reviewAppNumber}`;
      this.icon = ['far', 'code-branch'];
    } else if (this.currentEnvironment === 'pull-request') {
      this.color = 'positive';
      this.text = `Pull Request #${this.pullRequestNumber}`;
      this.icon = ['far', 'code-branch'];
    } else if (Object.keys(this.environment.environmentIndicator).length) {
      this.color = this.environment.environmentIndicator.color;
      this.text = this.environment.environmentIndicator.text;
      this.icon = ['far', this.environment.environmentIndicator.icon];
    } else {
      this.color = 'negative';
      this.text = 'Lokaal';
      this.icon = ['far', 'exclamation-triangle'];
    }
  }

  getReviewAppNumber(): string | undefined {
    // @ts-expect-error TS2531 object possibly null
    return this.beApiUrl?.includes('herokuapp') ? this.beApiUrl.match(/\d+/)[0] : undefined;
  }

  getPullRequestNumber(): string | undefined {
    if (this.appBaseHref !== '/') {
      const matches = this.appBaseHref.match(/^\/(\d+)\//);
      if (matches) {
        return matches[1];
      }
    }

    return undefined;
  }

  determineCurrentEnvironment() {
    let currentEnvironment = this.environment.environment;

    // TODO: it could be both a pull-request and a review-app
    if (currentEnvironment === 'staging' && this.reviewAppNumber) {
      currentEnvironment = 'review-app';
    } else if (currentEnvironment === 'staging' && this.pullRequestNumber) {
      currentEnvironment = 'pull-request';
    }
    return currentEnvironment;
  }

  clickButton() {
    if (this.currentEnvironment === 'review-app') {
      window.open(`https://github.com/reconcept-developers/portfolio-api/pull/${this.reviewAppNumber}`, '_blank');
    } else if (this.currentEnvironment === 'pull-request') {
      window.open(
        `https://github.com/reconcept-developers/reconcept-portfolio/pull/${this.pullRequestNumber}`,
        '_blank',
      );
    } else if (this.currentEnvironment === 'demo') {
      this.environmentButtonShown = false;
    }
  }
}
